import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { toLocalDate, toLocalTimeMinutes } from '../../utils/datetime.js';
import { GET_CALENDAR_AVAILABILITY } from '../../queries/get-calendar-availability.js';
import { fromCalendarAvailabilityQueryToCalendarAvailability } from './adapters/fromCalendarAvailabilityQueryToCalendarAvailability.js';

const useCalendarAvailability = ()=>{
    const [query, queryState] = useLazyQuery(GET_CALENDAR_AVAILABILITY, {
        fetchPolicy: 'no-cache',
        context: {
            timeout: 10000
        }
    });
    const getCalendarAvailability = React.useCallback(({ appointmentTypeId , storeCode , startDate , endDate , startTime , endTime  })=>{
        query({
            variables: {
                appointmentTypeIds: [
                    appointmentTypeId
                ],
                storeCodes: [
                    storeCode
                ],
                startDate: toLocalDate(startDate),
                endDate: toLocalDate(endDate),
                startTime: startTime ? toLocalTimeMinutes(startTime) : undefined,
                endTime: endTime ? toLocalTimeMinutes(endTime) : undefined
            }
        });
    }, [
        query
    ]);
    const data = React.useMemo(()=>fromCalendarAvailabilityQueryToCalendarAvailability(queryState.data)
    , [
        queryState.data
    ]);
    const { called , error , loading  } = queryState;
    return React.useMemo(()=>[
            getCalendarAvailability,
            {
                called,
                loading,
                data,
                error
            }
        ]
    , [
        getCalendarAvailability,
        called,
        loading,
        data,
        error
    ]);
};
var useCalendarAvailability$1 = useCalendarAvailability;

export { useCalendarAvailability$1 as default };
//# sourceMappingURL=use-calendar-availability.js.map
